import React, { useState } from 'react';
import {
  FaQuestionCircle,
  FaRegLifeRing,
  FaEnvelope,
  FaPhone,
} from 'react-icons/fa';

function HelpWidget() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="fixed bottom-6 left-6 z-50">
      <div
        className={`help-widget-container ${isOpen ? 'open' : ''} relative`}
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        <button
          className="p-3 bg-primary text-white rounded-full shadow-lg hover:bg-secondary transition-colors duration-300 focus:outline-none focus:ring-4 focus:ring-primary"
          onClick={toggleMenu}
          aria-label="Abrir menu de ajuda"
          aria-controls="help-widget-menu"
          aria-expanded={isOpen}
          type="button"
        >
          <FaQuestionCircle size={24} aria-hidden="true" />
        </button>

        {/* Menu de Ajuda */}
        <div
          id="help-widget-menu"
          className={`${
            isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
          } transition-all duration-300 ease-in-out absolute bottom-full left-0 mb-4 bg-white text-gray-800 rounded-lg shadow-xl p-4 w-72 md:w-80`}
          role="menu"
          aria-hidden={!isOpen}
        >
          <h3
            tabIndex="0"
            className="text-lg font-semibold text-primary mb-4 border-b border-gray-200 pb-2"
          >
            Precisa de Ajuda?
          </h3>

          <ul className="space-y-4">
            <li className="flex items-center">
              <FaRegLifeRing
                size={20}
                className="text-primary mr-3"
                aria-hidden="true"
              />
              <a
                href="/ajuda/duvidas-frequentes"
                role="menuitem"
                className="text-sm text-gray-700 hover:text-primary transition-colors duration-200 ease-in-out"
              >
                Perguntas Frequentes
              </a>
            </li>

            <li className="flex items-center">
              <FaPhone
                size={20}
                className="text-primary mr-3"
                aria-hidden="true"
              />
              <a
                href="/ajuda/suporte"
                role="menuitem"
                className="text-sm text-gray-700 hover:text-primary transition-colors duration-200 ease-in-out"
              >
                Suporte Técnico
              </a>
            </li>

            <li className="flex items-center">
              <FaEnvelope
                size={20}
                className="text-primary mr-3"
                aria-hidden="true"
              />
              <a
                href="/ajuda/contato"
                role="menuitem"
                className="text-sm text-gray-700 hover:text-primary transition-colors duration-200 ease-in-out"
              >
                Contato
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default HelpWidget;
